import { objectToParam } from '../../libs/utils';
import axios from '../api';

export async function getRegistrationParkings(registrationId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`registrations/${registrationId}/parkings?${parameters}`);
  return data;
}

export async function getRegistrationParking(registrationId, id) {
  const { data } = await axios.get(`registrations/${registrationId}/parkings/${id}`);
  return data;
}

export async function createRegistrationParking(registrationId, values) {
  const { data } = await axios.post(`registrations/${registrationId}/parkings`, values);
  return data;
}

export async function updateRegistrationParking(registrationId, id, values) {
  const { data } = await axios.put(`registrations/${registrationId}/parkings/${id}`, values);
  return data;
}

export async function deleteRegistrationParking(registrationId, id) {
  const { data } = await axios.delete(`registrations/${registrationId}/parkings/${id}`);
  return data;
}

export async function getParkingRequests(registrationId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`registrations/${registrationId}/parking-requests?${parameters}`);
  return data;
}

export async function getParkingRequest(registrationId, id) {
  const { data } = await axios.get(`registrations/${registrationId}/parking-requests/${id}`);
  return data;
}

export async function createParkingRequest(registrationId, values) {
  const { data } = await axios.post(`registrations/${registrationId}/parking-requests`, values);
  return data;
}

export async function deleteParkingRequest(registrationId, id) {
  const { data } = await axios.delete(`registrations/${registrationId}/parking-requests/${id}`);
  return data;
}
